import React from "react";
import { useDrop } from "react-dnd";
import { RenderMayaImages } from "../helpers";
import "./Box.css";


/* 
This component implements a box into which maya items can be dropped.
Parts of it were created with the help of LLMs.
*/
function MayaBoxDivision({ id, droppedItems, onDropItem, itemSize }) {
  const [, drop] = useDrop({
    accept: "maya",
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDropItem(item.id, id); // item.id is 2d-array. item[0] is index of item that was dropped, that index corresponds to a char (e.g. in Roman 2 = 'X'). id is the index of the box it was dropped in.
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });


  const boxStyle = {
    display: "flex",
    flexDirection: "row",
    width: "20dvh",
    height: "40dvh",
    zIndex: 0,
    filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))",
    borderRadius: "0.25em",
    alignItems: "center",
    justifyContent: "center",
  };

  const dropStyle = {
    maxWidth: boxStyle.width,
    maxHeight: boxStyle.height,
    backgroundColor: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "center",
    margin: "0 1dvh"
  };

  return (
    <div ref={drop} style={dropStyle}>
      <div alt="MayaBoxDivision" className="box" style={boxStyle}>
        <React.Fragment key={id}>
          <RenderMayaImages droppedItems={droppedItems} itemSize={itemSize}/>
        </React.Fragment>
      </div>
    </div>
  );
}

export default MayaBoxDivision;
